import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Badge } from "../../../components/ui/badge";
import {
  selectLanguagesData,
} from "../../../redux/selectors/languageSelectors";
import { selectSelectedLanguages } from "../../../redux/selectors/filterSelectors";
import { ChevronDown, ChevronRight } from "lucide-react";
import { formatLanguageName } from "../../../lib/utils";

function ActiveLanguages() {
  const [isOpen, setIsOpen] = useState(false);
  const selectedLanguages = useSelector(selectSelectedLanguages);
  const languages = useSelector(selectLanguagesData);
  const activeLanguages = languages.filter((lang) =>
    selectedLanguages.includes(lang.name)
  );

  return (
    <div className="polyglot-active-languages space-y-2">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex w-full items-center justify-between rounded-xl border border-input bg-white/70 px-3 py-2 text-xs uppercase tracking-wide text-muted-foreground"
        aria-expanded={isOpen}
      >
        <span>Active</span>
        <span className="flex items-center gap-2">
          ({activeLanguages.length})
          {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </span>
      </button>
      {isOpen && (
        <>
          {activeLanguages.length === 0 ? (
            <div className="rounded-xl border border-dashed border-input bg-white/60 px-3 py-3 text-sm text-muted-foreground">
              Select languages to pin them here.
            </div>
          ) : (
            <div className="grid gap-2">
              {activeLanguages.map((lang) => (
                <div
                  key={lang.id}
                  className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-input bg-white px-3 py-2 shadow-sm"
                >
                  <div className="flex items-center gap-2 min-w-0 flex-1">
                    <span className="text-sm font-medium whitespace-normal break-words">
                      {formatLanguageName(lang.name)}
                    </span>
                  </div>
                  {lang.name.toLowerCase().includes("audio") && (
                    <Badge variant="secondary" className="rounded-full shrink-0">
                      Audio
                    </Badge>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ActiveLanguages;
